import PropTypes from 'prop-types';
import React from 'react';
import ReactTable from 'react-table';
import { isNil } from 'lodash';

import { t } from '../../../../modules/infra/i18n';
import DateTime from '../../../common/DateTime';
import Money from '../../../common/money';
import Modal from '../../../common/Modal';
import DownloadButtonContainer from '../containers/DownloadButtonContainer';

const BalanceHistory = ({ cashRegisters, modalIsOn, modalOn, modalOff, disabled }) => (
  <div className="u-inline-block">
    <button
      type="button"
      className="c-btn c-btn--medium"
      disabled={disabled}
      onClick={modalOn}
    >
      {t('register:cash_register.balance_history_button')}

      <Modal
        display-if={modalIsOn}
        title={t('register:cash_register.balance_history_modal_title')}
        close={modalOff}
        showCloseButton
      >
        <div className="c-balance-history">
          <ReactTable
            className="c-table-new c-table--small c-no-hover u-width-1100 u-m ReactTable--sticky-header"
            noDataText={t('register:cash_register.no_transactions')}
            showPagination={false}
            minRows={0}
            defaultPageSize={200}
            data={cashRegisters}
            columns={[
              {
                Header: t('register:cash_register.balance_history_notes'),
                accessor: 'notes',
                Cell: row => row.value,
                className: 'no-text-overflow',
                minWidth: 180,
                maxWidth: 400,
              },
              {
                Header: t('register:cash_register.balance_history_close_date'),
                accessor: 'closedAt',
                id: 'close-date',
                minWidth: 150,
                Cell: (row) => {
                  if (row.original.opened) {
                    return t('register:cash_register.balance_history_current_register');
                  }
                  return <DateTime date={row.value} />;
                },
              },
              {
                Header: <span>{t('register:cash_register.balance_history_opening_balance')}</span>,
                accessor: 'startBalance',
                Cell: row => <Money cents={row.value} />,
                maxWidth: 200,
              },
              {
                Header: t('register:cash_register.balance_history_debits'),
                accessor: 'debits',
                Cell: row => <Money cents={row.value} />,
                maxWidth: 200,
              },
              {
                Header: t('register:cash_register.balance_history_credits'),
                accessor: 'credits',
                Cell: row => <Money cents={row.value} />,
                maxWidth: 200,
              },
              {
                Header: <span>{t('register:cash_register.balance_history_expected_closing')}</span>,
                id: 'close-balance',
                accessor: d => (d.opened ? d.currentBalance : d.endBalance),
                Cell: row => <Money cents={row.value} />,
                maxWidth: 200,
              },
              {
                Header: <span>{t('register:cash_register.balance_history_actual_balance')}</span>,
                accessor: 'actualEndBalance',
                Cell: row => (isNil(row.value) ? t('register:cash_register.balance_history_na') : <Money cents={row.value} />),
                maxWidth: 200,
              },
              {
                Header: <span>{t('register:cash_register.balance_history_closing_difference')}</span>,
                id: 'difference',
                accessor: d => (isNil(d.actualEndBalance) ? d.actualEndBalance : (d.actualEndBalance - d.endBalance)),
                Cell: row => (isNil(row.value) ? t('register:cash_register.balance_history_na') : <Money cents={row.value} />),
                maxWidth: 300,
                minWidth: 128,
              },
              {
                Header: <span>{t('register:cash_register.balance_history_balance_difference')}</span>,
                id: 'change',
                accessor: d => (isNil(d.actualEndBalance) ? null : d.actualEndBalance - d.startBalance),
                Cell: row => (isNil(row.value) ? t('register:cash_register.balance_history_na') : <Money cents={row.value} />),
                maxWidth: 200,
                minWidth: 128,
              },
            ]}
            defaultSorted={[
              {
                id: 'close-date',
                desc: true,
              },
            ]}
          />
        </div>
      </Modal>
    </button>
    <DownloadButtonContainer disabled={disabled} />
  </div>
);
BalanceHistory.propTypes = {
  cashRegisters: PropTypes.arrayOf(
    PropTypes.shape({
      closedAt: PropTypes.string,
      startBalance: PropTypes.number,
      debits: PropTypes.number,
      credits: PropTypes.number,
      endBalance: PropTypes.number,
    })
  ),
  modalOn: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  modalIsOn: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};
BalanceHistory.defaultProps = {
  cashRegisters: [],
};

export default BalanceHistory;
